<button
  class="flex w-full items-center justify-center outline-offset-1 outline-blue-600 focus:outline-2"
  [type]="htmlType"
  [disabled]="disabled"
  [ngClass]="{
    'bg-grey-200 text-grey-600 hover:bg-grey-300 active:bg-grey-400 disabled:bg-grey-100':
      defaultType,
    'bg-blue-600 text-white hover:bg-blue-700 active:bg-blue disabled:bg-blue-100 disabled:text-blue-300':
      primary,
    'border border-grey-300 bg-white text-grey-600 hover:border-grey-500 disabled:border-grey-100 disabled:bg-white':
      outline,

    'disabled:text-grey-400': defaultType || outline,

    'hover:bg-grey-100': transparent,
    'active:bg-grey-50': outline || transparent,

    'gap-1 rounded-md text-sm [&>svg-icon]:size-[0.87rem]': small,
    'gap-2 rounded-lg text-base [&>svg-icon]:size-5': defaultSize,
    'gap-4 rounded-xl text-lg [&>svg-icon]:size-8': large,

    'rounded-md': small && !circle,
    'rounded-lg': defaultSize && !circle,
    'rounded-xl': large && !circle,
    'rounded-full': circle,

    'px-4': small && !circle,
    'px-8': defaultSize && !circle,
    'px-10': large && !circle,

    'py-2': small && !circle,
    'py-4': defaultSize && !circle && !outline,
    'py-[calc(--spacing(4)-theme(borderWidth.2))]':
      defaultSize && !circle && outline,
    'py-6': large && !circle,

    'p-2': circle,
  }"
  (click)="emitTrigger()"
>
  <ng-content />
</button>
